import { useCallback } from "react";
import { FaBus } from "react-icons/fa";
import { BusStop, useBusSearch } from "../../../data/buses.api";
import { SearchSource } from "../MapSearch";

export const useBusStopsSource = (query: string): SearchSource<BusStop> => ({
  title: "Buses",
  source: useBusSearch(query),
  transformer: useCallback(
    (busStop) => ({
      icon: FaBus,
      iconColour: "yellow.600",
      title: busStop.commonName,
      subtitle: busStop.suburb,
      to: `/buses/${busStop.atcoCode}`,
    }),
    []
  ),
  priority: 0,
});
